class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message) {
    if (message.toLowerCase().includes("contact")) {
      this.actionProvider.handleContact();
    } else if (message.toLowerCase().includes("know")) {
      this.actionProvider.handleTrackOrder();
    } else if (message.toLowerCase().includes("track")) {
      this.actionProvider.handleTrackLink();
    }
  }
}

export default MessageParser;
